/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import type { SubscriptionDetail } from '@/services/requests/housien-services/AgenciesService.subscription';

/**
 * Resolves the plan name a subscriber should read.
 *
 * `plan.display_name` is a locale map on v3 plans but a plain string on legacy
 * ones, so it cannot be dereferenced directly. And when the subscription's
 * plan is missing from the catalogue the whole `plan` block is null, in which
 * case `billing.plan_name` carries the name the payment provider reported —
 * the only name there is for an off-catalogue plan.
 *
 * @param subscription - The subscription detail.
 * @returns The display name, or an empty string when nothing is known.
 */
export function resolvePlanName(subscription: SubscriptionDetail): string {
  const display = subscription.plan?.display_name;
  if (typeof display === 'string') return display;
  if (display && typeof display === 'object') return display.pt_br ?? '';
  return subscription.billing?.plan_name ?? '';
}
